
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as glOcD_45b4pRHaS6wtsnW4kCAMGkWYMd7mhTBIZz_45i2JmIMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexOPhMqaHRZ_45IWUUR0O7ROyOKJ7WkuunBZRdTn2zV_aH0Meta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchLBQteMyPjIIzC3I7Oo1S38H7okCLcnWkoQno12ZMMgUMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexiGbuq7ZHb96w0_RYkBiMWi32y2RP4Ozasp0T_xQkXtYMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93tygkyL9J9y_SBnpbpeEiioQrcImyJBtcf0go4EH5MNMMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexLiHPTlQGlhITZfWBoeC_ES8KVXpfcjF4lEAXPyXjxRwMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93yzAGwGZ9XC_45NIPX6PLCjlixw7apTyylXwJbRF7kZTQgMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexmk6Pu5zCT154rv0rHNdkIQGk__GAXjwhcQug3GDymwYMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93uGHODm_4nLPuwqHhjUp2JL7zLOZGenB_xMr57SRjRiIMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexBP2wtU_Y3SgRUC30quOiLUQkfhVjgD_ehG0P4Ege5oYMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexxbwHeliH1vgMaMnJrWW0PrJZnzh50lIwX3sQoJillqwMeta } from "/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexLiHPTlQGlhITZfWBoeC_ES8KVXpfcjF4lEAXPyXjxRwMeta || {},
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexmk6Pu5zCT154rv0rHNdkIQGk__GAXjwhcQug3GDymwYMeta || {},
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexBP2wtU_Y3SgRUC30quOiLUQkfhVjgD_ehG0P4Ege5oYMeta || {},
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexxbwHeliH1vgMaMnJrWW0PrJZnzh50lIwX3sQoJillqwMeta || {},
    component: () => import("/codebuild/output/src3992296019/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]